import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  Box,
  Button,
} from "@mui/material";
import Iconify from "../iconify/Iconify";

const FptsMax = 400;

export default function FilterPanel({
  filterPanelExpanded,
  setFilterPanelExpanded,
  filterInputs,
  handleInputChange,
  handleApplyFilters,
  handleClearFilters,
  filters,
}) {
  return (
    <Accordion
      expanded={filterPanelExpanded}
      onChange={(event, isExpanded) => setFilterPanelExpanded(isExpanded)}
      sx={{ mb: 3 }}
    >
      <AccordionSummary
        expandIcon={
          <Iconify
            icon={
              filterPanelExpanded ? "eva:arrow-up-fill" : "eva:arrow-down-fill"
            }
          />
        }
        sx={{
          backgroundColor: "#f5f5f5",
          "&:hover": { backgroundColor: "#eeeeee" },
        }}
      >
        <Typography variant="h6">
          Filter lineups by FPTS
          {!filterPanelExpanded && (
            <Typography
              component="span"
              variant="body2"
              sx={{ ml: 1, color: "text.secondary" }}
            >
              ({filters.fptsRange[0]} - {filters.fptsRange[1]})
            </Typography>
          )}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "#f5f5f5" }}>
        <Box sx={{ px: 2 }}>
          <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
            Filter lineups by FPTS range
          </Typography>

          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Min FPTS"
                type="number"
                value={filterInputs.fptsMin}
                onChange={(e) => handleInputChange("fptsMin", e.target.value)}
                inputProps={{ min: 0, max: FptsMax }}
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Max FPTS"
                type="number"
                value={filterInputs.fptsMax}
                onChange={(e) => handleInputChange("fptsMax", e.target.value)}
                inputProps={{ min: 0, max: FptsMax }}
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="contained"
                  onClick={handleApplyFilters}
                  startIcon={<Iconify icon="eva:search-outline" />}
                  size="small"
                >
                  Apply Filter
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<Iconify icon="eva:close-outline" />}
                  size="small"
                >
                  Clear Filters
                </Button>
              </Box>
            </Grid>
          </Grid>

          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontStyle: "italic" }}
          >
            Current active filter: {filters.fptsRange[0]} -{" "}
            {filters.fptsRange[1]} FPTS
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{ mt: 3, fontStyle: "italic", color: "text.secondary" }}
        >
          💡 Click on any column header to sort by that column
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
